import { render, staticRenderFns } from "./rows.vue?vue&type=template&id=15b1d520&"
import script from "./rows.vue?vue&type=script&lang=js&"
export * from "./rows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports